import { useDispatch, useSelector } from "react-redux";
import "./score.css";
import { useEffect } from "react";
import { PredictedScoreData, TargetScoreData } from "../../Action/ScoreAction";

export default function ScoreDetails() {
  const { laoding, error, PredictedScore } = useSelector(
    (s) => s.PredictedScoreDataReducer
  );

  const {
    laoding: loadingT,
    error: errorT,
    TargetScore,
  } = useSelector((s) => s.TargetScoreDataReducer);
  
  const dispatch = useDispatch();

  function switchTab(evt, tabId) {
    const contents = document.querySelectorAll(".tab-content");
    const links = document.querySelectorAll(".tab-link");
    contents.forEach((c) => c.classList.remove("active"));
    links.forEach((l) => l.classList.remove("active"));
    document.getElementById(tabId).classList.add("active");
    evt.currentTarget.classList.add("active");
  }

  useEffect(() => {
    dispatch(TargetScoreData());
    dispatch(PredictedScoreData());
  }, [dispatch]);

  return (
    <>
    {/* {loadingT || loading ? } */}
      <div className="Score">
        <div className="tabs">
          <div className="tab-buttons">
            <button
              className="tab-link active"
              onClick={(e) => switchTab(e, "predicted")}
            >
              <i className="fas fa-chart-line"></i> Predicted
            </button>
            <button
              className="tab-link"
              onClick={(e) => switchTab(e, "target")}
            >
              <i className="fas fa-bullseye"></i> Target
            </button>
          </div>

          <div id="predicted" className="tab-content active">
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>
                      <i className="fas fa-pen"></i> Writing
                    </th>
                    <th>
                      <i className="fas fa-book-open"></i> Reading
                    </th>
                    <th>
                      <i className="fas fa-microphone"></i> Speaking
                    </th>
                    <th>
                      <i className="fas fa-headphones"></i> Listening
                    </th>
                    <th>
                      <i className="fas fa-star"></i> Overall
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{PredictedScore?.Writing?.$numberDecimal || 0}</td>
                    <td>{PredictedScore?.Reading?.$numberDecimal || 0}</td>
                    <td>{PredictedScore?.Speaking?.$numberDecimal || 0}</td>
                    <td>{PredictedScore?.Listening?.$numberDecimal || 0}</td>
                    <td>{PredictedScore?.Overall?.$numberDecimal || 0}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div id="target" className="tab-content">
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>
                      <i className="fas fa-pen"></i> Writing
                    </th>
                    <th>
                      <i className="fas fa-book-open"></i> Reading
                    </th>
                    <th>
                      <i className="fas fa-microphone"></i> Speaking
                    </th>
                    <th>
                      <i className="fas fa-headphones"></i> Listening
                    </th>
                    <th>
                      <i className="fas fa-star"></i> Overall
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{TargetScore?.Writing?.$numberDecimal || 0}</td>
                    <td>{TargetScore?.Reading?.$numberDecimal || 0}</td>
                    <td>{TargetScore?.Speaking?.$numberDecimal || 0}</td>
                    <td>{TargetScore?.Listening?.$numberDecimal || 0}</td>
                    <td>{TargetScore?.Overall?.$numberDecimal || 0}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
